import { render, staticRenderFns } from "./general-ledger-enquiry-dev.vue?vue&type=template&id=5a8f913f&"
import script from "./general-ledger-enquiry-dev.vue?vue&type=script&lang=js&"
export * from "./general-ledger-enquiry-dev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports